import React from 'react'

import { IDashboardExample } from 'types/GlobalDashboardExample'

import Box from 'components_new/atoms/Box'
import Text from 'components_new/atoms/Text'

import GenericListItem from 'components_new/molecules/GenericListItem'

import { useTranslation } from 'language/translator'

interface AuthorProps {
  dashboard: IDashboardExample
  sx?: object
}

const Author = (props: AuthorProps) => {
  const { dashboard, sx } = props

  const { t } = useTranslation()

  return (
    <Box sx={sx}>
      <GenericListItem
        body={
          dashboard.author.company
            ? dashboard.author.company
            : new Date(dashboard.created_at).toLocaleDateString('sv')
        }
        component="div"
        disablePadding={true}
        size="medium"
        src={dashboard.author.url ? 'https:' + dashboard.author.url : undefined}
        sx={{ p: 0, mb: 2 }}
        title={
          dashboard.author.name
            ? dashboard.author.name
            : t('dashboards', 'created_by_homepal')
        }
        variant={dashboard.author.name ? 'user' : 'homepal'}
      />

      <Text color="text.secondary" variant="body2">
        {dashboard.author.name
          ? t('dashboards', 'created_by_customer_body')
          : t('dashboards', 'created_by_homepal_body')}
      </Text>
    </Box>
  )
}

export default Author
